<template>
  <span>
    <q-btn
      stack flat stretch
      :icon="icon"
      :label="!isPanoramaHeader ? label : this.$q.screen.gt.md ? label : null"
      :style="style"
      @click="$store.commit('basicLayout/showAuthDialog', true)"
    />
    <q-dialog v-model="showAuthDialog">
      <q-card style="min-width: 350px; min-height: 350px;">
        <q-card-section>
          <auth-panel />
        </q-card-section>
      </q-card>
    </q-dialog>
  </span>
</template>

<script>
import { QBtn, QDialog, QCard, QCardSection } from 'quasar'
import { AuthPanel } from '@giscube/geoportal'

export default {
  props: ['isPanoramaHeader'],
  data () {
    return {
      tool: this.$config.tools['auth']
    }
  },
  components: {
    AuthPanel, QBtn, QDialog, QCard, QCardSection
  },
  computed: {
    icon () {
      return this._getOrCall(this.tool.icon)
    },
    to () {
      const value = this._getOrCall(this.tool.to)
      if (typeof value === 'string') {
        return { name: value }
      } else {
        return value
      }
    },
    username () {
      return this.$store.state.auth.username
    },
    label () {
      return this.username || this.$t('tools.auth.headerName')
    },
    style () {
      return {
        'text-transform': this.username ? 'none' : undefined
      }
    },
    showAuthDialog: {
      set (show) {
        this.$store.commit('basicLayout/showAuthDialog', show)
      },
      get () {
        return this.$store.state.basicLayout.showAuthDialog
      }
    }
  },
  methods: {
    emit (event, value) {
      if (typeof event === 'string' && event) {
        this.$emit('event', { name: event, value })
      } else if (typeof event === 'object' && event.name.toString()) {
        this.$emit('event', event)
      } else {
        this.$except('[HeaderItemHolder.vue] Trying to emit an incorrectly configured event. Check your config.')
      }
    },
    _getOrCall (v) {
      if (v) {
        if (typeof v === 'function') {
          return v.call(this, this.tool)
        } else {
          return v
        }
      }
    }
  },
  watch: {
    username: function (username) {
      if (username) {
        this.$store.commit('basicLayout/showAuthDialog', false)
      }
    }
  }
}
</script>
